<template>
  <div class="mt-16">
    <v-row>
      <v-col>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>
            {{ $t('partCustomerPriceHistory.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row class="px-5">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="records"
          :no-data-text="$t('partCustomerPriceHistory.noData')"
          sort-by="validFrom"
          sort-desc
          hide-default-footer
          :items-per-page="-1"
        >
          <template #[`item.validFrom`]="{ item }">
            {{ item.validFrom | formatDateTime }}
          </template>
          <!-- <template #[`item.highlight`]="{ item }">
            <v-chip
              v-if="item.highlight"
              label
              small
            >
              Gældende
            </v-chip>
          </template> -->
          <template #[`item.price`]="{ item }">
            {{ item.price | formatNumberFixed2 }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'PartSupplierDetailHistory',
  props: {
    records: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('common.validFrom'), value: 'validFrom', sortable: false },
        // { text: '', value: 'highlight', sortable: false },
        { text: this.$t('common.price'), value: 'price', align: 'end', sortable: false }
      ]
    }
  }
}
</script>
